import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  id: 0,
  email: '',
  name: '',
  language: 'en',
  active: false,
  functions: [],
  token: ''
}

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setAdmin (state, action) {
      const { payload } = action
      return { ...initialState, ...payload }
    },
    setLogoutAdmin () {
      return { ...initialState }
    },
    setFunctions (state, action) {
      const { payload } = action
      state.functions = [...payload]
      return state
    }
  }
})

export const { setAdmin, setLogoutAdmin, setFunctions } = adminSlice.actions
export default adminSlice.reducer
